import React, { Component } from 'react'
import Icon from "../icon/icon.component.jsx"
import { injectIntl } from 'react-intl'
import GroupCalendarEventsDescription from './groupcalendareventsdescription.component.jsx';
const uuidv4 = require('uuid/v4')

class QuoteGroupName extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            group: this.props.value || null,
            type: this.props.type || 'quote',
            isRemovable: this.props.isRemovable || false,
            withEditIcon: this.props.withEditIcon || false,
            uniqueId: uuidv4(),
            name: this.props.value ? this.props.value.attributes.name : '',
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            showDescription: this.props.showDescription || false,
            onChange: this.props.onChange || function () {
            },
            modal: '',
            documentCalendarEvents: [],
            groupCalendarEventIds:
                this.props.value ? this.props.value.attributes.calendarEventIds : [],
            isPdf: this.props.isPdf || false,
        }
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.getModal = this.getModal.bind(this)
        this.onCloseModal = this.onCloseModal.bind(this)
        this.onSaveChange = this.onSaveChange.bind(this)
        this.updateModal = this.updateModal.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            group: nextProps.value || null,
            name: nextProps.value ? nextProps.value.attributes.name : '',
            description: nextProps.value ? nextProps.value.attributes.description : '',
            isRemovable: nextProps.isRemovable || false,
            withEditIcon: nextProps.withEditIcon || false,
            showDescription: nextProps.showDescription || false,
            documentCalendarEvents: nextProps.documentCalendarEvents || [],
            groupCalendarEventIds:
                nextProps.value ? nextProps.value.attributes.calendarEventIds : [],
        }, () => { if (this.state.modal != '') this.updateModal() })
    }

    getModal() {
        event.preventDefault()
        this.state.onChange()
        this.updateModal()
    }

    updateModal() {
        if (!this.state.isPdf) {
            var QuoteGroupNameModal = require("./groupnamemodal.component.jsx").default;
        }

        this.setState({
            modal: <QuoteGroupNameModal
                name={this.state.name}
                description={this.state.description}
                isRemovable={this.state.isRemovable}
                modalId={this.state.group?.id}
                groupId={this.state.group?.id}
                onUpdateCallback={this.props.onUpdateCallback}
                onSaveChange={this.onSaveChange}
                type={this.props.mainObject ?? `${this.props.type}s`}
                onCloseModal={this.onCloseModal}
                documentType={this.state.type}
                documentId={this.props.documentId}
                availableCalendarEvents={this.state.documentCalendarEvents || []}
                groupCalendarEventIds={this.state.groupCalendarEventIds || []}
            />,
            editMode: !this.state.editMode
        })
    }

    onSaveChange(name, description, calendarEventIds) {
        this.setState({
            name: name,
            description: description,
            calendarEventIds: calendarEventIds || []
        })
        this.onCloseModal()
    }

    onCloseModal() {
        this.setState({
            modal: '',
            editMode: !this.state.editMode
        })
        this.state.onChange()
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    showDescription() {
        return this.state.showDescription ?
            !this.state.description || this.state.description === '<p><br></p>' || this.state.description === '' ? '' :
                <div>
                    <hr />
                    <div className={'rich-text'} dangerouslySetInnerHTML={{ __html: this.state.description }} />
                </div>
            : ''
    }

    render() {
        if (!this.state.group) {
            return ''
        }

        const eventIds = this.state.groupCalendarEventIds || []
        if (!this.state.editable) {
            return (
                <span>
                    <div className="mb-2">
                        <strong>{this.state.name}</strong>
                    </div>
                    {this.showDescription()}
                    {this.state.showDescription &&
                        <GroupCalendarEventsDescription
                            calendarEvents={this.state.documentCalendarEvents.filter(e => eventIds.includes(e.id))}
                        />
                    }
                </span>
            )
        }

        const link = this.state.withEditIcon ?
            <span>
                <a href={'#'}
                    onClick={this.getModal}>
                    <small className={"text-white"}>
                        <Icon value={"edit"} className={'mr-2'} />
                    </small>
                </a>
                <strong>{this.state.name}</strong>
            </span> :

            <span>
                <a href={'#'}
                    onClick={this.getModal}
                    onMouseEnter={this.onMouseEnterHandler}
                    onMouseLeave={this.onMouseLeaveHandler}>
                    <strong>{this.state.name}</strong>
                    <Icon
                        value={'pencil-alt'}
                        className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')}
                    />
                </a>
                {this.showDescription()}
                <br />
                <GroupCalendarEventsDescription
                    calendarEvents={this.state.documentCalendarEvents.filter(e => eventIds.includes(e.id))}
                />
            </span>


        return (
            <span id={'group-' + this.state.group}>
                {link}
                {this.state.modal}
            </span>
        )
    }
}

export default injectIntl(QuoteGroupName);





// WEBPACK FOOTER //
// ./src/common/quote/groupname.component.jsx